import React, { useContext } from 'react';
import { FeaturesContext } from '@/app/contexts';

export const Welcome: React.FC = () => {
    const { featureFlags } = useContext(FeaturesContext) || {};
    
    return (
        <div className="flex flex-col items-center text-center mt-0">
            {/* <h1 className="flex flex-row text-3xl sm:text-6xl font-bold mb-8 font-satoshi">Welcome to TimePilot <div className="ml-1 sm:ml-3 mt-[1px] sm:mt-2 text-xl sm:text-[28px] font-thin">&reg;</div></h1>
            <div className="sm:flex hidden text-xl w-10/12 sm:w-full mb-6 sm:mb-8 font-satoshi items-center justify-center">
                Begin your case investigation by typing a question, <br />or clicking a suggested prompt below.
            </div> */}
            <div id="logo" className="flex flex-row items-center justify-center gap-2 sm:gap-4 leading-normal tracking-normal mq480:flex-wrap mb-10 sm:mb-20">
                <img
                className="relative object-contain w-[300px] sm:w-[600px] h-[111px] sm:h-[223px] mb-[-50px]"
                alt="TimePilot logo"
                src="/tp-logotype.png"
                />
            </div>
        </div>
    );
}